import script from "./TSI.vue?vue&type=script&lang=js"
export * from "./TSI.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__